import { COLORS } from '@/tokens';

interface BackgroundGridSVGProps {
  id: string;
  width?: number;
  height?: number;
  cellSize?: number;
  strokeWidth?: number;
  bgColor?: string;
  strokeColor?: string;
  className?: string;
}

// TODO should this be consolidated with other background pattern generators?
export function BackgroundGridSVG({
  id,
  cellSize = 32,
  strokeWidth = 0.5,
  bgColor = COLORS.GLOBAL['paper'],
  strokeColor = COLORS.GLOBAL['gray-100'],
  width = 2176,
  height = 992,
  className,
}: BackgroundGridSVGProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      id={`bg-grid-${id}`}
    >
      <defs>
        <pattern
          id={`rect-pattern-${id}`}
          width={cellSize}
          height={cellSize}
          patternUnits="userSpaceOnUse"
        >
          <rect
            x={strokeWidth * 0.5}
            y={strokeWidth * 0.5}
            width={cellSize - strokeWidth}
            height={cellSize - strokeWidth}
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            fill={bgColor}
          />
        </pattern>
      </defs>
      <rect width={width} height={height} fill={`url(#rect-pattern-${id})`} />
    </svg>
  );
}
